/** The path of every Firestore collection and document the app reads. */
export const collections = {
  users: 'users',
  user: (email: string) => `users/${email}`,
  branding: (organizationId: string) => `organizations/${organizationId}/settings/branding`,
  campaigns: (organizationId: string) => `organizations/${organizationId}/campaigns`,
  campaignExtractions: (organizationId: string, campaignId: string) =>
    `organizations/${organizationId}/campaigns/${campaignId}/extractions`,
  markets: (organizationId: string) => `organizations/${organizationId}/settings/markets`,
  anomalies: (organizationId: string, campaignId: string) =>
    `organizations/${organizationId}/campaigns/${campaignId}/anomalies`,
  brands: (organizationId: string) => `organizations/${organizationId}/brands`,
  templates: (organizationId: string) => `organizations/${organizationId}/templates`,
  generatedAssets: (organizationId: string) => `organizations/${organizationId}/generated_assets`,
  products: (organizationId: string, brandSlug: string) =>
    `organizations/${organizationId}/brands/${brandSlug}/products`,
  brandAssets: (organizationId: string, brandSlug: string) =>
    `organizations/${organizationId}/brands/${brandSlug}/assets`,
  brandProductImports: (organizationId: string, brandSlug: string) =>
    `organizations/${organizationId}/brands/${brandSlug}/product_imports`,
} as const;
